import { render, staticRenderFns } from "./ReportTzirosPerMonthPage.vue?vue&type=template&id=a59583b6&scoped=true"
import script from "./ReportTzirosPerMonthPage.vue?vue&type=script&lang=js"
export * from "./ReportTzirosPerMonthPage.vue?vue&type=script&lang=js"
import style0 from "./ReportTzirosPerMonthPage.vue?vue&type=style&index=0&id=a59583b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59583b6",
  null
  
)

export default component.exports